<template>
  <div class="login-screen">
    <div class="login-hero">
      <img :src="require('@/assets/images/syscore_logo_mini.svg')" alt="" class="login-hero__mark" />
      <div class="login-hero__copy">
        <img :src="require('@/assets/images/syscore_logo.svg')" alt="Syscore" class="login-hero__lockup" />
      </div>
    </div>

    <div class="login-form-side">
      <div class="login-form">
        <slot></slot>
        <div class="login-form__footer">SyscoreHR © {{ current_year }} · IngeniAR</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
  data: () => ({
    current_year: new Date().getFullYear(),
  }),
};
</script>
